import React from 'react';
import { StackScreen } from '@banhala/ui-kit';
import { WebView } from 'shared/src/component/WebWebView';
import { useWebBaseURL } from 'shared/src/hooks';
import { bridge, isNotNil } from 'shared/src/utils';
import { CartIcon } from 'shared/src/component';
import {
  NotificationIcon,
  SettingIcon,
} from 'shared/src/component/HeaderIcons';

const SCREEN_NAME = 'MY_PAGE';
export const MyPageScreen = () => {
  const webBaseUrl = useWebBaseURL();

  return (
    <StackScreen
      title={'마이페이지'}
      hideBackButton={true}
      rightIcons={[
        <SettingIcon screen={SCREEN_NAME} />,
        <NotificationIcon screen={SCREEN_NAME} />,
        <CartIcon
          onPressCart={() => {
            bridge.logAnalyticsEvent({
              name: 'CLICK_CART',
              analytics: {
                SCREEN: SCREEN_NAME,
                LANDING_FROM: 'CARTICON',
              },
            });
          }}
        />,
      ]}
    >
      {isNotNil(webBaseUrl) && (
        <WebView
          source={{ uri: `${webBaseUrl}/mypage/me?global_layout=app` }}
        />
      )}
    </StackScreen>
  );
};
